export default __webpack_public_path__ + "static/media/eurotux.bf079e6f.png";